import { apiSlice } from './apiSlice';

export interface TrackAnalyticsEventRequest {
  event_name: string;
  client_event_id: string;
  occurred_at?: string;
  properties: Record<string, unknown>;
  query_params?: Record<string, string>;
}

export interface TrackAnalyticsEventResponse {
  queued: boolean;
}

export const analyticsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    trackAnalyticsEvent: builder.mutation<TrackAnalyticsEventResponse, TrackAnalyticsEventRequest>({
      query: (body) => ({
        url: '/pa/events',
        method: 'POST',
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useTrackAnalyticsEventMutation } = analyticsApi;
